import { useMemo } from 'react';

import { DonutChart } from '../../common/DonutChart';
import { formatEUR } from '../../../utils/money';
import { INCOME_SOURCE_COLOR_PALETTE } from '../../../utils/incomeSourceColors';

function buildRows(data) {
  const usedColors = new Set();
  return (data || []).map((row, index) => {
    let color = row.color || '#7C9E6F';
    if (usedColors.has(color)) {
      color = INCOME_SOURCE_COLOR_PALETTE[index % INCOME_SOURCE_COLOR_PALETTE.length];
    }
    usedColors.add(color);
    return {
      id: `${row.name}-${index}`,
      name: row.name,
      value: Number(row.total || 0),
      percent: row.percentage != null ? Number(row.percentage) : null,
      color,
    };
  });
}

/**
 * `.pen` → `ds/chart/donut · valor central` (`tDnUd`) — interruptor `center`
 * ligado, `foot` desligado.
 *
 * `variant="plain"`: no relatório de selfie o cartão já é o `ReportPanel` à
 * volta, por isso o donut entra sem a casca própria (estrutura e tipografia
 * do master mantêm-se).
 */
export function ReportDonut({
  title,
  hint,
  data,
  centerLabel,
  centerValue,
  emptyLabel,
  showLegend = true,
}) {
  const rows = useMemo(() => buildRows(data), [data]);
  const total = useMemo(() => rows.reduce((sum, r) => sum + r.value, 0), [rows]);

  return (
    <DonutChart
      variant="plain"
      title={title}
      subtitle={hint}
      slices={rows}
      showLegend={showLegend}
      bodyLayout="stacked"
      center={{ label: centerLabel, value: centerValue ?? formatEUR(total) }}
      state={rows.length ? 'default' : 'empty'}
      emptyLabel={emptyLabel}
    />
  );
}

export default ReportDonut;
